import EguMstMaterial from "./EguMstMaterial";

function EguSubMaterialInfo ( props ) {
    return (
        <EguMstMaterial id="EguMstMaterial" />
    );
}

export default EguSubMaterialInfo;
